import React from "react";

export default function FAQ({ title = "FAQ", items = [], reveal = "true" }) {
  return (
    <section className="bd-faq">
      <div className={reveal ? "container" : "container reveal"} data-reveal>
        <h2 className="h2">{title}</h2>
        {items.map(({ q, a }, i) => (
          <details key={i}>
            <summary>{q}</summary>
            <div className="faq-content">
              {typeof a === "string" ? <p className="muted">{a}</p> : a}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
